import { AuthState, AuthActions, AuthMutations, Error, AuthLoginResponse, AuthLoginRequest, State } from '../types'
import { AuthCommitErrorStatus, AuthCommitWaitingStatus, AuthCommitToken } from './mutation-types'
import { AxiosError } from 'axios'
import api from '../api'
import { UserActionGet } from './action-types'
import { ActionContext } from 'vuex'
import router from '@/router'

const state: AuthState = {
  tokenType: '',
  expiresIn: 0,
  accessToken: '',
  status: {
    errors: false,
    message: '',
    isWaiting: false
  }
}
const mutations: AuthMutations = {
  errorStatus (state, payload) {
    if (!state.status) {
      return
    }
    state.status.errors = payload.errors
    state.status.message = payload.message
  },
  waitingStatus (state, payload) {
    if (!state.status) return
    state.status.isWaiting = payload.isWaiting
  },
  token (state, payload) {
    state.tokenType = payload.tokenType
    state.expiresIn = payload.expiresIn
    state.accessToken = payload.accessToken
    if (!payload.status) return
    state.status = {
      errors: payload.status.errors,
      message: payload.status.message
    }
  }
}
const actions: AuthActions = {
  request (ActionContext, { email, password }: AuthLoginRequest) {
    ActionContext.commit<AuthCommitWaitingStatus>({
      type: 'waitingStatus',
      isWaiting: true
    })
    api.user.login({ email, password })
      .then(handleAuth.success(ActionContext, () => {
        router.push({ name: 'Dashboard' })
      }))
      .catch(handleAuth.catch(ActionContext))
  },
  refresh (ActionContext, payload) {
    ActionContext.commit<AuthCommitWaitingStatus>({
      type: 'waitingStatus',
      isWaiting: true
    })
    api.user.refresh()
      .then(handleAuth.success(ActionContext, payload.successCallback))
      .catch(handleAuth.catch(ActionContext, payload.failCallback, payload.isLoginRoute))
  }
}

interface IHandleAuth {
  success(ActionContext: ActionContext<AuthState, State>, callback?: Function): (resp: AuthLoginResponse) => void
  catch(ActionContext: ActionContext<AuthState, State>, callback?: Function, isLoginRoute?: boolean): (error: AxiosError<Error>) => void
}
const handleAuth: IHandleAuth = {
  success ({ commit, dispatch }, callback = () => {}) {
    return (resp) => {
      const responseData = resp.data
      commit<AuthCommitToken>({
        type: 'token',

        tokenType: responseData.token_type,
        expiresIn: responseData.expires_in,
        accessToken: responseData.access_token,
        status: {
          errors: false,
          message: resp.message
        }
      })
      dispatch<UserActionGet>({
        type: 'user/get'
      }, { root: true })
      setTimeout(() => {
        dispatch({
          type: 'refresh',
          failCallback () {
            router.push('/login')
          }
        })
      }, (responseData.expires_in - 30/* second */) * 1000) // 1000 to convert second to milisecond
      callback()
      commit<AuthCommitWaitingStatus>({
        type: 'waitingStatus',
        isWaiting: false
      })
    }
  },
  catch ({ commit }, callback = () => {}, isLoginRoute = false) {
    return (err: AxiosError<Error>) => {
      if (!err.response) {
        commit<AuthCommitErrorStatus>({
          type: 'errorStatus',
          errors: true,
          message: err.message // 'Unknow.'
        })
        callback()
        commit<AuthCommitWaitingStatus>({
          type: 'waitingStatus',
          isWaiting: false
        })
        return
      }
      const { data } = err.response
      if (!isLoginRoute) {
        commit<AuthCommitErrorStatus>({
          type: 'errorStatus',
          errors: data.errors,
          message: data.message
        })
      }
      callback()
      commit<AuthCommitWaitingStatus>({
        type: 'waitingStatus',
        isWaiting: false
      })
    }
  }
}

export const auth = {
  state,
  mutations,
  actions
}
